/**
 * Accedo OVP
 * API version: 1.2.0
 *
 * NOTE: This class was automatically generated by Swagger Code Generator. Do not edit it manually.
 */
'use strict';

var ApiClient = require('./ApiClient');
var AuthSuccessResponse = require('./model/AuthSuccessResponse');
var Category = require('./model/Category');
var CategoryEntries = require('./model/CategoryEntries');
var CategoryPagedResponse = require('./model/CategoryPagedResponse');
var Channel = require('./model/Channel');
var ChannelEntries = require('./model/ChannelEntries');
var ChannelPagedResponse = require('./model/ChannelPagedResponse');
var Content = require('./model/Content');
var Credit = require('./model/Credit');
var Episode = require('./model/Episode');
var EpisodeEntries = require('./model/EpisodeEntries');
var EpisodePagedResponse = require('./model/EpisodePagedResponse');
var Error = require('./model/Error');
var Image = require('./model/Image');
var Media = require('./model/Media');
var MediaEntries = require('./model/MediaEntries');
var MediaPagedResponse = require('./model/MediaPagedResponse');
var Metadata = require('./model/Metadata');
var ParentalRating = require('./model/ParentalRating');
var Program = require('./model/Program');
var ResponsePagination = require('./model/ResponsePagination');
var TokenValidityResponse = require('./model/TokenValidityResponse');
var TvListing = require('./model/TvListing');
var TvListingEntries = require('./model/TvListingEntries');
var TvListingPagedResponse = require('./model/TvListingPagedResponse');
var TvSeason = require('./model/TvSeason');
var TvSeasonEntries = require('./model/TvSeasonEntries');
var TvSeasonPagedResponse = require('./model/TvSeasonPagedResponse');
var TvShow = require('./model/TvShow');
var TvShowEntries = require('./model/TvShowEntries');
var TvShowPagedResponse = require('./model/TvShowPagedResponse');

var AuthApi = require('./api/AuthApi');

var CategoryApi = require('./api/CategoryApi');

var ChannelApi = require('./api/ChannelApi');

var EpisodeApi = require('./api/EpisodeApi');

var MovieApi = require('./api/MovieApi');

var SearchApi = require('./api/SearchApi');

var TVListingApi = require('./api/TVListingApi');

var TVSeasonApi = require('./api/TVSeasonApi');

var TVShowApi = require('./api/TVShowApi');


  /**
   * The <code>index</code> module provides access to constructors for all the classes which comprise the public API.
   * <p><pre>
   * var AccedoOvp = require('index');
   * var xxxService = new AccedoOvp.XxxApi(); // Allocate the API class we're going to use.
   * var yyyModel = new AccedoOvp.Yyy(); // Construct a model instance.
   * yyyModel.someProperty = 'someValue';
   * ...
   * var zzz = xxxService.doSomething(yyyModel); // Invoke the service.
   * ...
   * </pre></p>
   * @module index
   * @version 1.4.0
   */
  var exports = {
    /**
     * The ApiClient constructor.
     * @property {module:ApiClient}
     */
    ApiClient: ApiClient,
    /**
     * The AuthSuccessResponse model constructor.
     * @property {module:model/AuthSuccessResponse}
     */
    AuthSuccessResponse: AuthSuccessResponse,
    /**
     * The Category model constructor.
     * @property {module:model/Category}
     */
    Category: Category,
    /**
     * The CategoryEntries model constructor.
     * @property {module:model/CategoryEntries}
     */
    CategoryEntries: CategoryEntries,
    /**
     * The CategoryPagedResponse model constructor.
     * @property {module:model/CategoryPagedResponse}
     */
    CategoryPagedResponse: CategoryPagedResponse,
    /**
     * The Channel model constructor.
     * @property {module:model/Channel}
     */
    Channel: Channel,
    /**
     * The ChannelEntries model constructor.
     * @property {module:model/ChannelEntries}
     */
    ChannelEntries: ChannelEntries,
    /**
     * The ChannelPagedResponse model constructor.
     * @property {module:model/ChannelPagedResponse}
     */
    ChannelPagedResponse: ChannelPagedResponse,
    /**
     * The Content model constructor.
     * @property {module:model/Content}
     */
    Content: Content,
    /**
     * The Credit model constructor.
     * @property {module:model/Credit}
     */
    Credit: Credit,
    /**
     * The Episode model constructor.
     * @property {module:model/Episode}
     */
    Episode: Episode,
    /**
     * The EpisodeEntries model constructor.
     * @property {module:model/EpisodeEntries}
     */
    EpisodeEntries: EpisodeEntries,
    /**
     * The EpisodePagedResponse model constructor.
     * @property {module:model/EpisodePagedResponse}
     */
    EpisodePagedResponse: EpisodePagedResponse,
    /**
     * The Error model constructor.
     * @property {module:model/Error}
     */
    Error: Error,
    /**
     * The Image model constructor.
     * @property {module:model/Image}
     */
    Image: Image,
    /**
     * The Media model constructor.
     * @property {module:model/Media}
     */
    Media: Media,
    /**
     * The MediaEntries model constructor.
     * @property {module:model/MediaEntries}
     */
    MediaEntries: MediaEntries,
    /**
     * The MediaPagedResponse model constructor.
     * @property {module:model/MediaPagedResponse}
     */
    MediaPagedResponse: MediaPagedResponse,
    /**
     * The Metadata model constructor.
     * @property {module:model/Metadata}
     */
    Metadata: Metadata,
    /**
     * The ParentalRating model constructor.
     * @property {module:model/ParentalRating}
     */
    ParentalRating: ParentalRating,
    /**
     * The Program model constructor.
     * @property {module:model/Program}
     */
    Program: Program,
    /**
     * The ResponsePagination model constructor.
     * @property {module:model/ResponsePagination}
     */
    ResponsePagination: ResponsePagination,
    /**
     * The TokenValidityResponse model constructor.
     * @property {module:model/TokenValidityResponse}
     */
    TokenValidityResponse: TokenValidityResponse,
    /**
     * The TvListing model constructor.
     * @property {module:model/TvListing}
     */
    TvListing: TvListing,
    /**
     * The TvListingEntries model constructor.
     * @property {module:model/TvListingEntries}
     */
    TvListingEntries: TvListingEntries,
    /**
     * The TvListingPagedResponse model constructor.
     * @property {module:model/TvListingPagedResponse}
     */
    TvListingPagedResponse: TvListingPagedResponse,
    /**
     * The TvSeason model constructor.
     * @property {module:model/TvSeason}
     */
    TvSeason: TvSeason,
    /**
     * The TvSeasonEntries model constructor.
     * @property {module:model/TvSeasonEntries}
     */
    TvSeasonEntries: TvSeasonEntries,
    /**
     * The TvSeasonPagedResponse model constructor.
     * @property {module:model/TvSeasonPagedResponse}
     */
    TvSeasonPagedResponse: TvSeasonPagedResponse,
    /**
     * The TvShow model constructor.
     * @property {module:model/TvShow}
     */
    TvShow: TvShow,
    /**
     * The TvShowEntries model constructor.
     * @property {module:model/TvShowEntries}
     */
    TvShowEntries: TvShowEntries,
    /**
     * The TvShowPagedResponse model constructor.
     * @property {module:model/TvShowPagedResponse}
     */
    TvShowPagedResponse: TvShowPagedResponse,
    /**
     * The AuthApi service constructor.
     * @property {module:api/AuthApi}
     */
    AuthApi: AuthApi,
    /**
     * The CategoryApi service constructor.
     * @property {module:api/CategoryApi}
     */
    CategoryApi: CategoryApi,
    /**
     * The ChannelApi service constructor.
     * @property {module:api/ChannelApi}
     */
    ChannelApi: ChannelApi,
    /**
     * The EpisodeApi service constructor.
     * @property {module:api/EpisodeApi}
     */
    EpisodeApi: EpisodeApi,
    /**
     * The MovieApi service constructor.
     * @property {module:api/MovieApi}
     */
    MovieApi: MovieApi,
    /**
     * The SearchApi service constructor.
     * @property {module:api/SearchApi}
     */
    SearchApi: SearchApi,
    /**
     * The TVListingApi service constructor.
     * @property {module:api/TVListingApi}
     */
    TVListingApi: TVListingApi,
    /**
     * The TVSeasonApi service constructor.
     * @property {module:api/TVSeasonApi}
     */
    TVSeasonApi: TVSeasonApi,
    /**
     * The TVShowApi service constructor.
     * @property {module:api/TVShowApi}
     */
    TVShowApi: TVShowApi
  };

module.exports = exports;
